import { Flex, FlexProps } from '@chakra-ui/react';
import React from 'react';

export interface IconOverlayProps extends FlexProps {
	icon: React.ReactNode;
	left?: string | number;
}

const IconOverlay: React.FC<IconOverlayProps> = ({
	icon,
	left = '12px',
	...props
}) => (
	<Flex
		position="absolute"
		h="full"
		alignItems="center"
		left={left}
		zIndex="1"
		{...props}>
		{icon}
	</Flex>
);

export default IconOverlay;
